export function getQuerySearch(searchParams: string) {
  const parsedQuery = new URLSearchParams(searchParams);
  const search = parsedQuery.get('search');
  return search || '';
}
